import { Component } from '@angular/core';
import { SessionService } from '../../services/session.service';
import { AdminService } from '../../services/admin.service';

@Component({
  selector: 'pdf-header',
  templateUrl: './pdf-header.html'
})
export class PDFHeaderComponent {
  constructor(
    public sessionService: SessionService,
    public adminService: AdminService
  ) {}
}



// WEBPACK FOOTER //
// ./src/components/pdf-header/pdf-header.component.ts